exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settingCard[data-v-85dff1e6] {\r\n  width: 100%;\n}\r\n", ""]);

// exports
